import {
    GET_JOB_REQUEST, GET_JOB_SUCCESS, GET_JOB_FAIL,
    GET_ALL_JOBS_REQUEST, GET_ALL_JOBS_SUCCESS, GET_ALL_JOBS_FAIL,
    GET_ACTIVE_JOBS_REQUEST, GET_ACTIVE_JOBS_SUCCESS, GET_ACTIVE_JOBS_FAIL,
    GET_JOBS_BY_CATEGORY_REQUEST, GET_JOBS_BY_CATEGORY_SUCCESS, GET_JOBS_BY_CATEGORY_FAIL,
    CREATE_JOB_REQUEST, CREATE_JOB_SUCCESS, CREATE_JOB_FAIL,
    UPDATE_JOB_REQUEST, UPDATE_JOB_SUCCESS, UPDATE_JOB_FAIL,
    DELETE_JOB_REQUEST, DELETE_JOB_SUCCESS, DELETE_JOB_FAIL,
    SET_JOB_LOADING, UPDATE_JOB, DOWNLOAD_JOBS_TEMPLATE_REQUEST, EXPORT_JOBS_REQUEST, DOWNLOAD_JOBS_TEMPLATE_SUCCESS,
    EXPORT_JOBS_SUCCESS, DOWNLOAD_JOBS_TEMPLATE_FAIL, EXPORT_JOBS_FAIL, IMPORT_JOBS_EXCEL_REQUEST,
    IMPORT_JOBS_EXCEL_SUCCESS, IMPORT_JOBS_EXCEL_FAIL, CLEAR_JOBS_IMPORT_RESULT
} from '../actions/Jobactions';
import {CLEAR_FORMATIONS_IMPORT_RESULT} from "../actions/formationsActions";

const initialState = {
    jobs: [],
    currentJob: null,
    loading: false,
    message: '',
    bulkLoading:  false,
    importResult: null,   // résultat dryRun ou import réel
    error: null
};

function jobReducer(state = initialState, action) {
    switch (action.type) {
        case UPDATE_JOB:
            return {
                ...state,
                loading: true,
                job: action.job
            };

        // --- SET LOADING ---
        case SET_JOB_LOADING:
            return {
                ...state,
                loading: action.payload
            };
        case CLEAR_JOBS_IMPORT_RESULT:
            return { ...state, importResult: null };

        // --- Récupérer un poste ---
        case GET_JOB_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case GET_JOB_SUCCESS:
            return {
                ...state,
                currentJob: action.payload,
                loading: false,
                message: 'Poste récupéré avec succès'
            };
        case GET_JOB_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error,
                message: 'Échec de la récupération'
            };

        // --- Récupérer tous les postes ---
        case GET_ALL_JOBS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case GET_ALL_JOBS_SUCCESS:
            return {
                ...state,
                jobs: action.payload,
                loading: false,
                message: ''
            };
        case GET_ALL_JOBS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        // --- Récupérer postes actifs ---
        case GET_ACTIVE_JOBS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case GET_ACTIVE_JOBS_SUCCESS:
            return {
                ...state,
                jobs: action.payload,
                loading: false,
                message: 'Postes actifs récupérés avec succès'
            };
        case GET_ACTIVE_JOBS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        // --- Récupérer postes par catégorie ---
        case GET_JOBS_BY_CATEGORY_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case GET_JOBS_BY_CATEGORY_SUCCESS:
            return {
                ...state,
                jobs: action.payload,
                loading: false,
                message: ''
            };
        case GET_JOBS_BY_CATEGORY_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        // --- Créer un poste ---
        case CREATE_JOB_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case CREATE_JOB_SUCCESS:
            return {
                ...state,
                jobs: [...state.jobs, action.payload],
                loading: false,
                message: ''
            };
        case CREATE_JOB_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        // --- Mettre à jour un poste ---
        case UPDATE_JOB_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case UPDATE_JOB_SUCCESS:
            return {
                ...state,
                jobs: state.jobs.map(job =>
                    job.id === action.payload.id ? action.payload : job
                ),
                currentJob: state.currentJob?.id === action.payload.id
                    ? action.payload
                    : state.currentJob,
                loading: false,
                message: ''
            };
        case UPDATE_JOB_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        // --- Supprimer un poste ---
        case DELETE_JOB_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case DELETE_JOB_SUCCESS:
            return {
                ...state,
                jobs: state.jobs.filter(job => job.id !== action.payload.jobId),
                currentJob: state.currentJob?.id === action.payload.jobId
                    ? null
                    : state.currentJob,
                loading: false,
                message: ''
            };
        case DELETE_JOB_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        // ── Template + Export (pas de payload utile) ──────
        case DOWNLOAD_JOBS_TEMPLATE_REQUEST:
        case EXPORT_JOBS_REQUEST:
            return { ...state, bulkLoading: true, error: null };

        case DOWNLOAD_JOBS_TEMPLATE_SUCCESS:
        case EXPORT_JOBS_SUCCESS:
            return { ...state, bulkLoading: false };

        case DOWNLOAD_JOBS_TEMPLATE_FAIL:
        case EXPORT_JOBS_FAIL:
            return { ...state, bulkLoading: false, error: action.payload || "Erreur" };

        // ── Import Excel ──────────────────────────────────
        case IMPORT_JOBS_EXCEL_REQUEST:
            return { ...state, bulkLoading: true, error: null, importResult: null };

        case IMPORT_JOBS_EXCEL_SUCCESS:
            return { ...state, bulkLoading: false, importResult: action.payload };

        case IMPORT_JOBS_EXCEL_FAIL:
            return { ...state, bulkLoading: false, error: action.payload || "Erreur import Excel" };


        default:
            return state;
    }
}

export default jobReducer;